import { Pagination as MuiPagination } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Pagination = ({ pageCount = 1, page = 1, onChange, sx = {} }) => {
    const { i18n } = useTranslation();
    const rtl = i18n.dir() === 'rtl';

    return (
        <MuiPagination
            dir="ltr"
            count={pageCount}
            page={page}
            onChange={(e, page) => onChange(page)}
            color="primary"
            sx={{ ...sx, display: 'flex', justifyContent: 'center' }}
            // renderItem={item => (
            //     <PaginationItem
            //         components={{
            //             previous: NavigateBefore,
            //             next: NavigateNext,
            //         }}
            //         {...item}
            //     />
            // )}
        />
    );
};

export default Pagination;
